

function dealerWithdrawEMoney() {

    let profileService = [
        {
            name: "Withdraw E-Money",
            icon: "Withdraw E-Money",
            logoName: "fee",
            // flag: "voucherRequired",
            displayService: "dealerWithdrawEMoney",
            items: [],
        },
    ];

    const dashboard = () => {
        const dashboardArr = [
            {
                path: "/index/dealerWithdrawEMoney",
                name: "Dashboard",
                icon: "dashboard",
                logoName: "dashboard",
                flag: "",
            },
        ];

        return dashboardArr;
    };

    const withdrawEMoney = () => {
        const profileArr = [
            {
                path: "/index/withdrawEMoney",
                name: "Withdraw E-Money",
                icon: "fee-master",
                logoName: "Withdraw_E_Money",
            },
        ];
        return profileArr;
    };


    let a = dashboard();
    let b = withdrawEMoney();

    profileService[0].items = [...a, ...b];

    return profileService;
}

export default dealerWithdrawEMoney;
